import type { ReactElement } from 'react';

import { TemplatesPage as TemplatesFeaturePage } from '../features/templates/pages/TemplatesPage.js';

export default function TemplatesPage(): ReactElement {
  return <TemplatesFeaturePage />;
}
